import { FunctionalComponent, h } from "@stencil/core";

import { Bundle } from "../../services/i18n";
import {
  NotificationItem,
  NotificationResponse,
} from "../../services/notification/notification.service";

import { parseTrackingString } from "../../services/tracking/tracking-utils";
import { NotificationBoxLight } from "./NotificationBoxLight";

import { TRACKING_CATEGORY } from "./consts";

export const NotificationList: FunctionalComponent<
  NotificationResponse & {
    i18n: Bundle;
    i18nEnglish: Bundle;
    trackByEvent(event: Event): void;
  }
> = ({ items: notifications, i18n, i18nEnglish, trackByEvent }) => {
  return (
    <div class="inlay container">
      <div class="notification--content">
        {notifications?.map((notification: NotificationItem) => (
          <NotificationBoxLight
            notification={notification}
            trackByEvent={trackByEvent}
          />
        ))}
      </div>

      <div class="row">
        <div class="col-md further-activities">
          <a
            class="link"
            role="link"
            tabindex="0"
            href="/myswisscom/activities"
            onClick={trackByEvent}
            title={i18n.t("NOTIFICATIONS_SHOW_ALL_ACTIVITIES")}
            data-tracking-category={TRACKING_CATEGORY}
            data-tracking-label={
              "notification-" +
              parseTrackingString(
                i18nEnglish.t("NOTIFICATIONS_SHOW_ALL_ACTIVITIES"),
              )
            }
          >
            {i18n.t("NOTIFICATIONS_SHOW_ALL_ACTIVITIES")}
          </a>
        </div>
      </div>
    </div>
  );
};
